import { Review, PlasterApplicator } from "@/types";

export const reviews: Review[] = [
  {
    id: "1",
    name: "Sarah Johnson",
    rating: 5,
    comment:
      "The Gray Wool microcement transformed my kitchen. Perfect industrial look and so easy to clean. The applicator we found through the directory was professional and detailed.",
    date: "2024-11-15",
    verified: true,
    location: "Austin, TX",
  },
  {
    id: "2",
    name: "Michael Chen",
    rating: 5,
    comment:
      "Used Terracotta for my bathroom renovation. The water resistance is excellent and it looks incredibly modern. Highly recommend both the product and the directory!",
    date: "2024-11-08",
    verified: true,
    location: "Portland, OR",
  },
  {
    id: "3",
    name: "Lisa Rodriguez",
    rating: 4,
    comment:
      "Great product and helpful directory. The texture and finish of the Downing Sands color are beautiful. Installation took patience but the result is worth it.",
    date: "2024-10-28",
    verified: true,
    location: "Miami, FL",
  },
  {
    id: "4",
    name: "David Thompson",
    rating: 5,
    comment:
      "Professional contractor here - I've specified Concretta on multiple high-end projects. Quality is consistent and clients love the sophisticated concrete look.",
    date: "2024-10-20",
    verified: true,
    location: "Seattle, WA",
  },
  {
    id: "5",
    name: "Emily Davis",
    rating: 5,
    comment:
      "The Light Taupe microcement transformed our living room. The seamless finish is stunning and the applicator we hired through the site was excellent.",
    date: "2024-10-12",
    verified: true,
    location: "Nashville, TN",
  },
  {
    id: "6",
    name: "James Wilson",
    rating: 4,
    comment:
      "Used for our commercial office renovation. Handles high traffic beautifully and maintenance is minimal. Very happy with the durability.",
    date: "2024-09-30",
    verified: true,
    location: "Chicago, IL",
  },
  {
    id: "7",
    name: "Rachel Martinez",
    rating: 5,
    comment:
      "The Brick color is perfect for our modern loft. Great customer service and the applicator directory made finding a skilled professional easy.",
    date: "2024-09-22",
    verified: true,
    location: "Brooklyn, NY",
  },
  {
    id: "8",
    name: "Tom Anderson",
    rating: 5,
    comment:
      "WhirlyBird finish in our bathroom is gorgeous. Water-resistant and easy to maintain. The whole process from ordering to installation was seamless.",
    date: "2024-09-15",
    verified: true,
    location: "Denver, CO",
  },
  {
    id: "9",
    name: "Jessica Park",
    rating: 4,
    comment:
      "Very pleased with the Super Nova color for our feature wall. Product arrived quickly and the finish exceeded our expectations.",
    date: "2024-08-28",
    verified: true,
    location: "Los Angeles, CA",
  },
  {
    id: "10",
    name: "Marcus Brown",
    rating: 5,
    comment:
      "Dark Jade looks incredible in our master bathroom. The applicator network is a game-changer - found a certified pro in days.",
    date: "2024-08-20",
    verified: true,
    location: "Atlanta, GA",
  },
  {
    id: "11",
    name: "Amanda Foster",
    rating: 5,
    comment:
      "Golden Harvest has the perfect warm tone for our cafe. Customers constantly ask about the walls. Worth every penny.",
    date: "2024-08-10",
    verified: true,
    location: "San Francisco, CA",
  },
  {
    id: "12",
    name: "Kevin O'Brien",
    rating: 4,
    comment:
      "Solid product for commercial use. We've done three restaurant projects with it now. Durable and looks great even after heavy use.",
    date: "2024-07-25",
    verified: true,
    location: "Boston, MA",
  },
];

export const applicatorsByCity: Record<string, PlasterApplicator[]> = {
  "New York": [
    {
      id: "ny1",
      name: "Metropolitan Plaster Pros",
      city: "New York",
      state: "NY",
      phone: "(212) 555-0123",
      email: "info@metroplaster.com",
      website: "www.metroplaster.com",
      specialties: ["Microcement", "Venetian Plaster", "Decorative Finishes"],
      rating: 4.8,
      reviewCount: 127,
    },
    {
      id: "ny2",
      name: "Brooklyn Concrete Artisans",
      city: "Brooklyn",
      state: "NY",
      phone: "(718) 555-0456",
      email: "hello@brooklynartisans.com",
      specialties: ["Concretta Application", "Industrial Finishes"],
      rating: 4.9,
      reviewCount: 89,
    },
    {
      id: "ny3",
      name: "Manhattan Surface Studio",
      city: "Manhattan",
      state: "NY",
      phone: "(212) 555-0789",
      email: "contact@surfacestudio.nyc",
      website: "www.surfacestudio.nyc",
      specialties: [
        "Luxury Microcement",
        "Bathroom Specialists",
        "Kitchen Surfaces",
      ],
      rating: 4.7,
      reviewCount: 156,
    },
  ],
  "Los Angeles": [
    {
      id: "la1",
      name: "LA Modern Surfaces",
      city: "Los Angeles",
      state: "CA",
      phone: "(323) 555-0234",
      email: "info@lamodern.com",
      website: "www.lamodern.com",
      specialties: ["Concretta", "Modern Finishes", "Residential"],
      rating: 4.6,
      reviewCount: 203,
    },
    {
      id: "la2",
      name: "Venice Plaster Works",
      city: "Venice",
      state: "CA",
      phone: "(310) 555-0567",
      email: "team@veniceplaster.com",
      specialties: ["Microcement", "Artistic Finishes", "Commercial Projects"],
      rating: 4.8,
      reviewCount: 91,
    },
    {
      id: "la3",
      name: "Beverly Hills Concrete Co.",
      city: "Beverly Hills",
      state: "CA",
      phone: "(424) 555-0890",
      email: "luxury@bhconcrete.com",
      website: "www.bhconcrete.com",
      specialties: ["Luxury Microcement", "High-End Residential", "Pool Areas"],
      rating: 4.9,
      reviewCount: 134,
    },
  ],
  Chicago: [
    {
      id: "chi1",
      name: "Windy City Surfaces",
      city: "Chicago",
      state: "IL",
      phone: "(312) 555-0345",
      email: "info@windycitysurfaces.com",
      specialties: [
        "Concretta Installation",
        "Industrial Spaces",
        "Loft Conversions",
      ],
      rating: 4.7,
      reviewCount: 112,
    },
    {
      id: "chi2",
      name: "Great Lakes Plaster",
      city: "Chicago",
      state: "IL",
      phone: "(773) 555-0678",
      email: "hello@greatlakesplaster.com",
      website: "www.greatlakesplaster.com",
      specialties: ["Microcement", "Decorative Walls", "Restaurants"],
      rating: 4.5,
      reviewCount: 87,
    },
  ],
  Miami: [
    {
      id: "mia1",
      name: "Miami Beach Finishes",
      city: "Miami Beach",
      state: "FL",
      phone: "(305) 555-0456",
      email: "info@miamibeachfinishes.com",
      specialties: [
        "Tropical Microcement",
        "Humidity Resistant",
        "Luxury Condos",
      ],
      rating: 4.8,
      reviewCount: 145,
    },
    {
      id: "mia2",
      name: "South Florida Concrete",
      city: "Miami",
      state: "FL",
      phone: "(786) 555-0789",
      email: "team@sflconcrete.com",
      website: "www.sflconcrete.com",
      specialties: ["Concretta", "Pool Decks", "Outdoor Living"],
      rating: 4.6,
      reviewCount: 98,
    },
  ],
  Austin: [
    {
      id: "aus1",
      name: "Austin Artisan Surfaces",
      city: "Austin",
      state: "TX",
      phone: "(512) 555-0567",
      email: "hello@austinartisan.com",
      specialties: ["Microcement", "Modern Homes", "Tech Company Offices"],
      rating: 4.9,
      reviewCount: 176,
    },
    {
      id: "aus2",
      name: "Hill Country Plaster",
      city: "Austin",
      state: "TX",
      phone: "(737) 555-0890",
      email: "info@hillcountryplaster.com",
      website: "www.hillcountryplaster.com",
      specialties: ["Concretta Application", "Ranch Homes", "Custom Finishes"],
      rating: 4.7,
      reviewCount: 103,
    },
  ],
  Seattle: [
    {
      id: "sea1",
      name: "Pacific Northwest Surfaces",
      city: "Seattle",
      state: "WA",
      phone: "(206) 555-0678",
      email: "info@pnwsurfaces.com",
      specialties: [
        "Weather Resistant Microcement",
        "Coffee Shops",
        "Modern Lofts",
      ],
      rating: 4.8,
      reviewCount: 129,
    },
    {
      id: "sea2",
      name: "Emerald City Plaster",
      city: "Seattle",
      state: "WA",
      phone: "(425) 555-0901",
      email: "team@emeraldcityplaster.com",
      website: "www.emeraldcityplaster.com",
      specialties: ["Concretta", "Sustainable Finishes", "Tech Offices"],
      rating: 4.6,
      reviewCount: 84,
    },
  ],
  Denver: [
    {
      id: "den1",
      name: "Rocky Mountain Microcement",
      city: "Denver",
      state: "CO",
      phone: "(303) 555-0789",
      email: "info@rockymountainmc.com",
      specialties: [
        "High Altitude Application",
        "Ski Lodges",
        "Mountain Homes",
      ],
      rating: 4.7,
      reviewCount: 95,
    },
  ],
  Nashville: [
    {
      id: "nas1",
      name: "Music City Surfaces",
      city: "Nashville",
      state: "TN",
      phone: "(615) 555-0890",
      email: "hello@musiccitysurfaces.com",
      specialties: ["Concretta", "Recording Studios", "Music Venues"],
      rating: 4.8,
      reviewCount: 118,
    },
  ],
  Portland: [
    {
      id: "por1",
      name: "Portland Concrete Co.",
      city: "Portland",
      state: "OR",
      phone: "(503) 555-0901",
      email: "info@portlandconcrete.com",
      website: "www.portlandconcrete.com",
      specialties: [
        "Eco-Friendly Microcement",
        "Craft Breweries",
        "Industrial Chic",
      ],
      rating: 4.9,
      reviewCount: 167,
    },
  ],
};
